<template>
  <b-form>
    <b-row>

      <b-col md="6">
        <b-form-group
          :label="$t('meeting.props.title')"
          label-for="mc-first-name"
        >
          <b-form-input placeholder="Title" v-model="newItem.title" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group
          :label="$t('meeting.props.type')"
          label-for="mc-last-name"
        >
          <b-form-select
            v-model="newItem.type"
            :options="types"
            class="mb-3"
            value-field="uuid"
            text-field="name"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-col md="12">
          <b-form-group>
            <h5>{{ $t("meeting.props.scheduled_on") }}</h5>
            <flat-pickr
              v-model="newItem.start_date_time"
              class="form-control"
              :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <h5>{{ $t("meeting.props.estimated_period") }}</h5>
            <b-form-spinbutton
              id="demo-sb"
              v-model="newItem.period"
              min="30"
              max="240"
            />
          </b-form-group>
        </b-col>
      </b-col>
      <b-col md="9">
        <b-form-group
          :label="$t('meeting.props.estimated_period')"
          label-for="mc-country"
        >
          <b-form-textarea
            placeholder="Agenda"
            rows="6"
            v-model="newItem.agenda"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group
          :label="$t('meeting.props.description')"
          label-for="mc-company"
        >
          <ckeditor
            :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
            v-model="newItem.description"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="6">
        <b-button block :disabled="invalid" variant="primary" @click="submit()">
          <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
        >
      </b-col>
      <b-col lg="6">

        <b-button block  @click="goToTable()" variant="success">
          <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
        >
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Controller from "../../../../Controllers/ConnectController";
import config from "../../../../config/config";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import Auth from "@/Apis/Auth";

const controller = new Controller();
export default {
  name: "ConnectForm",
  components: {
    flatPickr,
    vSelect,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      formErrors: {},
      types: [],
    };
  },
  async created() {
    const data = await controller.preRequisite();
    this.types = data.types;
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.newItem.room_id = localStorage.getItem("room");
      const ret = await controller.From(this.newItem, "newItem");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },

    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
